import React, { useMemo } from "react";

// Style
import "../Status.scss"

// Components
import InStock from "./InStock";
import Temporarily from "./Temporarily";
import Button from "components/UiKit/Button";
import FieldSelect from "components/UiKit/FieldSelect";

// Actions
import { openModal } from "reducers/modal";
import { toggleModal } from "reducers/settings";
import { showMessage } from "reducers/messages";
import * as actionsCreatorProject from "pages/Projects/reducer";
import { handlerChangeCurrentProject } from "pages/Projects/reducer";

// Lib
import { shallowEqual } from "react-redux";
import { useAppDispatch, useAppSelector } from "lib/hooks/useDispatch";
import { convertedToArray, convertProjectsToOptions } from "lib/helpers";

// Constants
import { styleFieldSelect } from "constans/checkout";

// Type
import { TPrices } from "pages/MoleculeProduct/reducer";

type TOptions = {
  label: string;
  value: string;
}

// Interface
interface IStatus {
  prices?: any;
  onStock?: boolean;
}

export const Status: React.FC<IStatus> = (props) => {
  const { prices, onStock } = props;
  const dispatch = useAppDispatch();

  const {
    user,
    currentProject,
    dataProjects,

    quantity,
    disabled,
    moleculeInfo,
    currentPrice,

    typePrice
  } = useAppSelector(
    (store) => {
      return {
        user: store.settings.user,

        dataProjects: store.projects.dataProjects,
        currentProject: store.projects.currentProject,

        quantity: store.moleculeProduct.count,
        disabled: store.moleculeProduct.disabled,
        moleculeInfo: store.moleculeProduct.data,
        currentPrice: store.moleculeProduct.currentPrice,

        typePrice: store.settings.typePrice,
      };
    },
    shallowEqual
  );

  const options = convertProjectsToOptions(dataProjects);
  const convertedProjects = convertedToArray(dataProjects);

  const countAvailable = prices?.filter(
    (item: TPrices) => !item.available
  )?.length;

  const handlerSubmit = () => {
    if (!user.authorized) {
      dispatch(toggleModal(true));
      return;
    }

    const uniqId = crypto.randomUUID();
    if (!currentPrice.value) {
      dispatch(showMessage({
        type: "info",
        uniqId: uniqId,
        text: disabled ? "Temporarily unavailable" : "Choose price/mg"
      }));
      return;
    }

    const findProductId: any = moleculeInfo.supIds?.find(
      (item: any) => item.supplier === typePrice
    );

    const html = document.createElement("div");
    html.innerHTML = findProductId?.supId || '';
    const result = [
      {
        quantity: quantity,
        supplier: typePrice,
        productId: html.innerText,
        prepackage: currentPrice.mg
      }
    ];

    if (currentProject) {
      dispatch(actionsCreatorProject.addItemToProject({
        data: result,
        uniqId: uniqId,
        id: currentProject,
        title: "Compound Added to project",
        text: "Review or continue browsing. Contact<br/> us for any questions. Thank you!"
      }));
      return;
    }

    if (!currentProject) {
      const modalConfig = {
        data: result,
        isAddItem: "isAddItem",
        title: "Compound Added to project",
        type: convertedProjects.length ? "projectsList" : "projectAdd",
        text: "Review or continue browsing. Contact<br/> us for any questions. Thank you!"
      };

      dispatch(openModal(modalConfig));
    }
  };

  const handlerChangeProject = (selected: TOptions) => {
    dispatch(handlerChangeCurrentProject(selected.value));
  };

  const valueSelectProject = useMemo(() => options?.filter(
    (x: TOptions) => +x?.value === +currentProject
  ), [options, currentProject]);

  const styleSelect = {
    ...styleFieldSelect,
    container: (provided: any) => ({
      ...provided,
      "&:hover, &:focus": {},
      width: "100%",
      color: "#060606",
      maxWidth: "100%",
      fontWeight: "500",
      fontSize: "1.4rem",
      fontStyle: "normal",
      lineHeight: "1.8rem",
      letterSpacing: "0.8px",
      fontFamily: "Poppins",
      paddingBottom: "1rem",
      height: "3.5rem",
      borderBottom: "1px solid #060606",

      "@media only screen and (max-width: 1024px)": {
        ...provided["@media only screen and (max-width: 1024px)"],
        maxWidth: "100%"
      }
    }),
    input: (p: any) => ({
      ...p,
      margin: 0,
      padding: 0,
      color: "#191919",
      minHeight: "2.4rem"
    }),
    value: (p: any) => ({
      ...p,
      lineHeight: "1.8rem",
      height: "2.4rem"
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: "#191919",
      fontWeight: "400",
      fontSize: "1.4rem",
      fontStyle: "normal",
      lineHeight: "1.8rem",
      fontFamily: "Poppins",
      letterSpacing: "0.8px"
    }),
    menu: (provided: any) => ({
      ...provided,
      "&:hover, &:focus": {}
    }),
    control: (provided: any) => ({
      ...provided,
      "&:hover, &:focus": {
        borderColor: "unset"
      },
      height: "3.5rem",
      border: "unset",
      width: "100%",
      color: "#060606",
      boxShadow: "none",
      maxWidth: "100%",
      cursor: "pointer",
      fontWeight: "500",
      fontSize: "1.4rem",
      fontStyle: "normal",
      borderStyle: "unset",
      lineHeight: "1.8rem",
      borderRadius: "unset",
      letterSpacing: "0.8px",
      fontFamily: "Poppins",
      backgroundColor: "transparent",

      "@media only screen and (max-width: 1024px)": {
        ...provided["@media only screen and (max-width: 1024px)"],
        maxWidth: "100%"
      }
    })
  };

  return (
    <>
      <FieldSelect
        options={options}
        styles={styleSelect}
        name="currentProject"
        value={valueSelectProject}
        className="full-width mb30"
        disabled={!user.authorized}
        placeholder="Select project"
        label="Your current project"
        onChange={handlerChangeProject}
      />

      <div className="status flex flex-ai-center flex-jc-between">
        {onStock && <InStock />}
        {!onStock && <Temporarily />}

        <Button
          variable="info"
          typePadding="small"
          label="Add to project"
          onPress={handlerSubmit}
          disabled={!onStock || prices.length === countAvailable}
        />
      </div>
    </>
  );
};

export default Status;